package api.repository.propertyOwners

import api.data.DataPropertyOwner
import api.service.propertyOwners.ServicePropertyOwners

class ImplRepositoryPropertyOwners(val servicePropertyOwners: ServicePropertyOwners): RepositoryPropertyOwners{
    override suspend fun getPropertyOwners(): ArrayList<DataPropertyOwner>? {
        return servicePropertyOwners.getPropertyOwners()
    }

}